/* eslint-disable max-classes-per-file */
import { IDagKvantitet } from "~app/common/models/dagkvantitet";
import { ForsorjningskallaAggregat, ForsorjningskallaTyp } from "~app/common/models/forsorjningskalla";
import { ICommand } from "~app/common/services/cqs/command.service";
import { CommandBase } from "~app/common/services/cqs/commandManager";

export class SetForsorjningsradAvtaladProduktionsomradeCommand extends CommandBase {
    kundorderradId: number;
    produktionsomradeId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetForsorjningsradAvtaladProduktionsomradeCommand) => void) {
        super("SetForsorjningsradAvtaladProduktionsomradeCommand");
        init(this);
    }
}

export class SetForsorjningsradAvtaladTerminalCommand extends CommandBase {
    kundorderradId: number;
    mottagningsplatsId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetForsorjningsradAvtaladTerminalCommand) => void) {
        super("SetForsorjningsradAvtaladTerminalCommand");
        init(this);
    }
}

export class SetForsorjningsradAvtaladLevorderCommand extends CommandBase {
    kundorderradId: number;
    leverantorsorderradId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetForsorjningsradAvtaladLevorderCommand) => void) {
        super("SetForsorjningsradAvtaladLevorderCommand");
        init(this);
    }
}

export class SetForsorjningsradAvtaladCommandFactory {

    static createSetForsorjningsradAvtaladCommand(
        model: ForsorjningskallaAggregat,
        kundorderradId: number,
        periodStart: Date,
        periodEnd: Date,
        fordeladKvantitet: IDagKvantitet[]): ICommand {
        switch (model.typ) {
            case ForsorjningskallaTyp.Produktionsomrade:
                return new SetForsorjningsradAvtaladProduktionsomradeCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.produktionsomradeId = model.id;
                    c.periodStart = periodStart;
                    c.periodEnd = periodEnd;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            case ForsorjningskallaTyp.Terminal:
                return new SetForsorjningsradAvtaladTerminalCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.mottagningsplatsId = model.id;
                    c.periodStart = periodStart;
                    c.periodEnd = periodEnd;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            case ForsorjningskallaTyp.Leverantorsorder:
                return new SetForsorjningsradAvtaladLevorderCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.leverantorsorderradId = model.id;
                    c.periodStart = periodStart;
                    c.periodEnd = periodEnd;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            default:
                throw new Error(`Odefinierad typ: ${model.typ}`);
        }
    }
}
